import i18next from 'i18next';

/**
 * Os tres idiomas do lancamento, na mesma ordem e com os mesmos valores do
 * `enum Locale` do contrato. Alterar aqui sem alterar o contrato produz um
 * cliente que pede um idioma que o servidor recusa.
 */
export const SUPPORTED_LOCALES = ['pt-BR', 'en-US', 'es'] as const;

export type SupportedLocale = (typeof SUPPORTED_LOCALES)[number];

export const DEFAULT_LOCALE: SupportedLocale = 'pt-BR';

export function isSupportedLocale(value: unknown): value is SupportedLocale {
  return (
    typeof value === 'string' && (SUPPORTED_LOCALES as readonly string[]).includes(value)
  );
}

/**
 * Casa `pt`, `pt-br`, `en`, `es-AR` e afins com um dos tres locales.
 * Devolve `undefined` quando nada casa, para que quem chama saiba a diferenca
 * entre "pediu portugues" e "nao pediu nada reconhecivel".
 */
export function matchLocale(candidate: string | undefined | null): SupportedLocale | undefined {
  if (!candidate) return undefined;
  if (isSupportedLocale(candidate)) return candidate;

  const normalized = candidate.toLowerCase();
  const exact = SUPPORTED_LOCALES.find((locale) => locale.toLowerCase() === normalized);
  if (exact) return exact;

  const language = normalized.split('-')[0];
  return SUPPORTED_LOCALES.find((locale) => locale.toLowerCase().split('-')[0] === language);
}

/** Como `matchLocale`, mas cai no default do contrato quando nada casa. */
export function resolveLocale(candidate: string | undefined | null): SupportedLocale {
  return matchLocale(candidate) ?? DEFAULT_LOCALE;
}

/**
 * Idioma corrente para o cabecalho `Accept-Language`. Lido do i18next na hora
 * da chamada, e nao capturado na inicializacao, porque a troca de idioma e
 * instantanea e a proxima requisicao ja precisa sair no idioma novo.
 */
export function getRequestLocale(): SupportedLocale {
  return resolveLocale(i18next.language);
}
